/* Azərbaycan telefon nömrəsi — xanada sabit «+994», müştəri 9 rəqəmi yazır
   (təsisçi qərarı, 2026-10-21). Yapışdırılan / avtodoldurulan «+994 55 885
   55 22», «0558855522», «994558855522» hamısı eyni 9 rəqəmə düşür; serverə
   `+994` + 9 rəqəm gedir (serverdəki `phone.py` ilə EYNİ qayda).

   «99» həm də operator kodudur (099), ona görə «994» yalnız 12 rəqəmli tam
   nömrədə atılır; baş sıfırlar həmişə atılır (yerli nömrə 0 ilə başlamır). */
export const AZ_LOCAL_LEN = 9;

export function azLocalDigits(raw) {
  const s = String(raw || "");
  let d = s.replace(/\D/g, "");
  if (s.trim().startsWith("00")) d = d.slice(2);
  d = d.replace(/^0+/, "");
  if (d.startsWith("9940") && d.length === 13) d = "994" + d.slice(4);
  if (d.startsWith("994") && d.length === 12) d = d.slice(3);
  return d.slice(0, 12);
}

export const isAzLocalComplete = (d) => d.length === AZ_LOCAL_LEN;

export const toE164 = (d) => `+994${d}`;

/* 55 885 55 22 — yazdıqca qruplaşır. */
export function formatAzLocal(d) {
  const parts = [d.slice(0, 2), d.slice(2, 5), d.slice(5, 7), d.slice(7, 9), d.slice(9)];
  return parts.filter(Boolean).join(" ");
}
